import React from 'react';
import { createPortal } from 'react-dom';
import { Alert, Snackbar } from '@mui/material';
import { NotificationProps } from './types';
import { AlertContainer } from './styles';

export const Notification = ({
  type,
  open,
  onClose,
  children,
  autoHideDuration = 6000,
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
}: NotificationProps) => {
  return (
    <>
      {createPortal(
        <Snackbar
          {...{
            open,
            autoHideDuration,
            onClose,
            anchorOrigin,
          }}
        >
          <Alert {...{ onClose, severity: type, css: AlertContainer }}>
            {children}
          </Alert>
        </Snackbar>,
        document.body
      )}
    </>
  );
};
